import Vue from 'vue';
import {
  UPDATE_WIDGET,
  UPDATE_CLOCK,
  UPDATE_FEED,
  UPDATE_STATE,
  CLEAR_CLOCK_TIMER,
  DELETE_FEED,
  DELETE_STATE,
  PUSH_TO_ARRAY,
} from '@/store/actions/widget';

const namespaced = true;

/* eslint-disable arrow-body-style */
const state = () => {
  return {
    id: null,
    name: null,
    icon: null,
    component: null,
    layoutID: null,
    mediaID: null,
    data: {
      states: [],
    },
    dataAudio: {
      src: null,
      type: null,
      loop: 0,
      volume: 1,
    },
    dataClock: {
      hours: null,
      minutes: null,
      seconds: null,
      timer: null,
    },
    dataImage: {
      src: null,
      preview: null,
    },
    dataPdf: {
      src: null,
      delay: 3,
      loop: 0,
    },
    dataText: {
      text: null,
    },
    dataTicker: {
      feeds: [],
    },
    dataVideo: {
      src: null,
      loop: 0,
      volume: 1,
      hardwareAcceleration: 0,
      playerType: 'vlc',
    },
    dataVnc: {
      address: null,
      port: null,
      password: null,
    },
    dataWeb: {
      src: null,
      preview: null,
      delay: 300,
    },
    dataYoutube: {
      src: null,
      type: null,
      loop: 0,
    },
    dataTwitter: {
      src: null,
      delay: 300,
    },
    dataRss: {
      src: null,
      delay: 300,
    },
    dataFacebook: {
      src: null,
      delay: 300,
    },
    dataMagio: {
      channelId: null,
    },
    style: {
      horizontalAlign: 'center',
      verticalAlign: 'center',
      deformation: 0,
      backgroundColor: '#FF0000',
      color: '#000000',
      fontSize: 30,
      justifyContent: null,
      alignItems: null,
      animationDuration: 3,
      display: null,
      paddingLeft: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      zIndex: 0,
      /* These are used for drag&drop element */
      w: 200,
      h: 200,
      x: 0,
      y: 0,
      r: 0,
    },
  };
};
/* eslint-enable */

/* eslint-disable no-shadow, arrow-body-style */
const getters = {
  getName: (state) => state.name,
  getItem: (state) => state,
};
/* eslint-enable */

const actions = {
  UPDATE_WIDGET: ({ commit }, payload) => {
    commit(UPDATE_WIDGET, payload);
  },
  UPDATE_CLOCK: ({ commit }) => {
    commit(UPDATE_CLOCK);
  },
  CLEAR_CLOCK_TIMER: ({ commit }) => {
    commit(CLEAR_CLOCK_TIMER);
  },
  UPDATE_FEED: ({ commit }, payload) => {
    commit(UPDATE_FEED, payload);
  },
  UPDATE_STATE: ({ commit }, payload) => {
    commit(UPDATE_STATE, payload);
  },
  DELETE_FEED: ({ commit }, index) => {
    commit(DELETE_FEED, index);
  },
  DELETE_STATE: ({ commit }, index) => {
    commit(DELETE_STATE, index);
  },
  PUSH_TO_ARRAY: ({ commit }, payload) => {
    commit(PUSH_TO_ARRAY, payload);
  },
};

/* eslint-disable no-shadow, arrow-body-style, no-param-reassign */
const mutations = {
  UPDATE_WIDGET: (state, payload) => {
    payload.data.forEach((data) => {
      if (data.path === '') {
        state[data.key] = data.value;
      } else {
        state[data.path][data.key] = data.value;
      }
    });
  },
  UPDATE_CLOCK: (state) => {
    const now = new Date();

    state.dataClock.hours = now.getHours();
    state.dataClock.minutes = (`0${now.getMinutes()}`).slice(-2);
    state.dataClock.seconds = (`0${now.getSeconds()}`).slice(-2);
  },
  CLEAR_CLOCK_TIMER: (state) => {
    window.clearInterval(state.dataClock.timer);
  },
  UPDATE_FEED: (state, payload) => {
    Vue.set(state.dataTicker.feeds, payload.index, payload.value);
  },
  UPDATE_STATE: (state, payload) => {
    payload.data.forEach((data) => {
      state.data.states[data.index][data.key] = data.value;
    });
  },
  DELETE_FEED: (state, index) => {
    state.dataTicker.feeds.splice(index, 1);
  },
  DELETE_STATE: (state, index) => {
    state.data.states.splice(index, 1);
  },
  PUSH_TO_ARRAY: (state, payload) => {
    state[payload.data.path][payload.data.key].push(payload.data.value);
  },
};
/* eslint-enable */

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
